const articleJumplinks = (function () {
	let userClickedLink = false;

	function createArticleJumplinksDesktop() {
		// Create HTML -- Desktop
		const stickyWrapper = document.querySelector('.mod-article-jumplinks__wrapper');
		if (!stickyWrapper) {
			return;
		}
		const articleHeadings = document.querySelectorAll('.jumplink-heading');
		const ul = document.createElement('ul');
		articleHeadings.forEach(function (heading, index) {
			const li = document.createElement('li');
			const linkButton = document.createElement('button');
			heading.dataset.jumplink = `jumplink-${index + 1}`;
			linkButton.dataset.jumplinkAnchor = `jumplink-${index + 1}`;
			linkButton.textContent = heading.textContent;
			linkButton.className = 'mod-article-jumplinks__link';
			li.appendChild(linkButton);
			ul.appendChild(li);
		});
		stickyWrapper.appendChild(ul);
	}

	function createArticleJumplinksMobile() {
		// Create HTML -- Mobile
		const articleJumplinkDetails = document.querySelector('.mod-article-jumplinks__mobile .mod-details');
		if (!articleJumplinkDetails) {
			return;
		}
		const articleHeadings = document.querySelectorAll('.jumplink-heading');
		const div = document.createElement('div');
		const ul = document.createElement('ul');
		articleHeadings.forEach(function (heading, index) {
			const li = document.createElement('li');
			const linkButton = document.createElement('button');
			linkButton.textContent = heading.textContent;
			linkButton.dataset.jumplinkAnchor = `jumplink-${index + 1}`;
			linkButton.className = 'mod-article-jumplinks__link';
			li.appendChild(linkButton);
			ul.appendChild(li);
		});
		div.appendChild(ul);
		articleJumplinkDetails.appendChild(div);
	}

	function handleArticleJumplinksScroll() {
		if (userClickedLink) {
			return;
		}
		const stickyWrapper = document.querySelector('.mod-article-jumplinks__wrapper');
		if (!stickyWrapper) {
			return;
		}
		const articleHeadings = document.querySelectorAll('.jumplink-heading');
		articleHeadings.forEach(function (heading) {
			let linkButton;
			const rect = heading.getBoundingClientRect();
			const elemTop = rect.top;
			const elemBottom = rect.bottom;
			const isVisible = elemTop >= 0 && elemBottom <= window.innerHeight - 150;
			const dataJumplink = heading.dataset.jumplink;
			if (dataJumplink !== null) {
				linkButton = document.querySelector(`.mod-article-jumplinks [data-jumplink-anchor='${dataJumplink}']`);
			}
			const activeHeading = document.querySelector('.mod-article-jumplinks li.active');
			if (isVisible) {
				if (linkButton !== null) {
					if (activeHeading !== null) {
						activeHeading.classList.remove('active');
					}
					linkButton.closest('li').classList.add('active');
				}
			}
		});
	}

	function handleArticleJumplinksClick(event) {
		const el = event.target;
		if (el.classList.contains('mod-article-jumplinks__link')) {
			userClickedLink = true;
			const activeHeading = document.querySelector('.mod-article-jumplinks li.active');
			// Scroll to heading
			const dataJumplink = el.dataset.jumplinkAnchor; //jumplink-1
			const heading = document.querySelector(`[data-jumplink='${dataJumplink}']`);
			const offset = 60;
			const headingPosition = heading.getBoundingClientRect().top;
			const offsetPosition = headingPosition + window.pageYOffset - offset;
			window.scrollTo({
				top: offsetPosition,
				behavior: 'smooth',
			});
			// Handle active class on jumplinks
			if (activeHeading !== null) {
				activeHeading.classList.remove('active');
			}
			el.closest('li').classList.add('active');
			setTimeout(function () {
				userClickedLink = false;
			}, 1000);
		}
	}

	return {
		createArticleJumplinksMobile: createArticleJumplinksMobile,
		createArticleJumplinksDesktop: createArticleJumplinksDesktop,
		handleArticleJumplinksScroll: handleArticleJumplinksScroll,
		handleArticleJumplinksClick: handleArticleJumplinksClick,
	};
})();

window.addEventListener('load', function () {
	articleJumplinks.createArticleJumplinksMobile();
	articleJumplinks.createArticleJumplinksDesktop();
	if (window.matchMedia('(max-width: 840px)').matches) {
		return;
	}
	articleJumplinks.handleArticleJumplinksScroll();
});

window.addEventListener('scroll', function () {
	articleJumplinks.handleArticleJumplinksScroll();
});

document.addEventListener('click', function (event) {
	articleJumplinks.handleArticleJumplinksClick(event);
});
